module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/gi-bill-faq.json
// module id = 1918
// module chunks = 244175986731484